module.exports = __webpack_public_path__ + "img/button-finney-hover.e35cb291.png";